module.exports = __webpack_public_path__ + "img/icon_claim_reward.ed02053f.png";